import React, { FC, RefObject, useState, MouseEvent, TouchEvent } from 'react'

import { Sizes } from 'components/layout/Sizes'
import { calculatePositionLeft } from 'components/page/ForeignProfile/Gifts/function/calculatePositionLeft'
import { GiftDescription } from 'components/page/ForeignProfile/Gifts/GiftDescription/GiftDescription'
import {
  Img,
  GiftItem,
} from 'components/page/ForeignProfile/Gifts/Gifts.styled'
import { isDraggableDevice } from 'components/page/PhotoRating/function/isDraggableDevice'
import { createGiftUrlForForeignProfile } from 'components/page/Profile/function/createGiftUrl'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

import { GQLForeignRootQuery } from '../gql/__generated__/ForeignRoot'

export const GiftsList: FC<{
  gifts: NonNullable<GQLForeignRootQuery['user']>['gifts']['gifts']['nodes']
  giftsCommonFormat: GQLForeignRootQuery['ui']['giftFormats']
  parent: RefObject<HTMLDivElement>
}> = ({ gifts, giftsCommonFormat, parent }) => {
  const { authorized } = useShallowEqualSelector(
    ({ authorizationReducer: { authorized } }) => ({
      authorized,
    })
  )

  const [coordinatesMap, setCoordinatesMap] = useState<
    Record<number, { left: number; top: number }>
  >({})

  const handlePosition = (giftId: number, event: MouseEvent | TouchEvent) => {
    const element = (
      event.currentTarget === event.target ? event.target : event.currentTarget
    ) as HTMLElement
    if (parent.current) {
      const left = calculatePositionLeft(parent.current, element)
      const constTopOffset = window.innerWidth > Sizes.tablet ? 15 : 5

      setCoordinatesMap((coordinates) => ({
        ...coordinates,
        [giftId]: {
          left: left,
          top: element.offsetHeight - constTopOffset,
        },
      }))
    }
  }

  const handleMouseEnter = (
    giftId: number,
    event: MouseEvent<HTMLDivElement>
  ) => {
    event.preventDefault()

    if (!isDraggableDevice()) {
      handlePosition(giftId, event)
    }
  }

  const handleTouchStart = (
    giftId: number,
    event: TouchEvent<HTMLDivElement>
  ) => {
    const target = event.target as HTMLElement
    if (target.tagName.toLowerCase() === 'button') {
      return
    }

    handlePosition(giftId, event)
  }

  return (
    <>
      {gifts.map(
        ({
          giftId,
          message,
          senderProfile,
          senderHidden,
          image: { name, formats: giftSupportFormat },
          my,
        }) => {
          const imageUrl = createGiftUrlForForeignProfile(
            name,
            giftSupportFormat,
            giftsCommonFormat
          )
          const coordinates = coordinatesMap[giftId]

          return (
            <GiftItem
              key={giftId}
              data-name={`wrapper-${giftId}-gift-id`}
              onMouseEnter={(event) => handleMouseEnter(giftId, event)}
              onTouchStart={(event) => handleTouchStart(giftId, event)}
            >
              <Img src={imageUrl} data-name={`${giftId}-gift-id`} />
              {authorized && coordinates && (
                <GiftDescription
                  giftId={giftId}
                  greeting={message}
                  authorProfile={senderProfile}
                  isAuthorHidden={senderHidden}
                  isGiftFromCurrentUser={my}
                  left={coordinates.left}
                  top={coordinates.top}
                />
              )}
            </GiftItem>
          )
        }
      )}
    </>
  )
}
